import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import CommonButton from "../../../../../component/Button";
import DropDownSelect from "../../../../../component/Select";
import { StyledDialog } from "../../../../common-components/StyledComponents";

const AddUpdateActiveJob = ({
  open,
  onClose,
  title,
  activeOptions = [],
  onApply,
  backgroundImage,
  id,
}) => {
  const [titleValue, setTitleValue] = useState("");

  const activeJobData = [
    {
      label: "Job",
      placeholder: "Select a job",
      data: [
        { id: 1, label: "UX Designer 100001", name: "UX Designer 100001" },
        {
          id: 2,
          label: "Product Designer 100002",
          name: "Product Designer 100002",
        },
      ],
      onChange: (e) => setTitleValue(e.target.value),
      value: titleValue,
    },
  ];

  const dialogTitle =
    title || (id ? "Update To Active Job" : "Add To Active Job");

  return (
    <StyledDialog fullWidth maxWidth="xs" open={open} onClose={onClose}>
      <DialogActions>
        <Button onClick={onClose}>
          <CloseIcon />
        </Button>
      </DialogActions>
      <DialogTitle>
        <Typography variant="h3" sx={{ mt: 2 }}>
          {dialogTitle}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Grid container direction="column" gap={2}>
          {activeJobData.map((option, index) => (
            <Grid item key={index}>
              <Typography
                color="#344054"
                fontSize={14}
                fontFamily="Inter"
                fontWeight={500}
              >
                {option.label}
              </Typography>
              <DropDownSelect
                title={option.placeholder || "Select an option"}
                data={option.data}
                handleChange={option.onChange}
                value={option.value}
              />
            </Grid>
          ))}
          <CommonButton
            variant="contained"
            color="white"
            background="#7F56D9"
            fontWeight="600"
            value="Add"
            padding="8px"
            onClick={onApply}
          />
        </Grid>
      </DialogContent>
    </StyledDialog>
  );
};

export default AddUpdateActiveJob;
